export default "__VITE_ASSET__BCYclkt8__"